<template>
  <p
    class="control has-icons-left has-text-centered m1rema"
  >
    <button
      class="facility button is-rounded w90"
      :class="{'active-facility': selected }"
      @click="select($event)"
    >
      <span
        class="icon is-small is-left checkboxContainer"
      >
        <Checkbox :selected="selected" />
      </span>
      <div
        class="facility-text ml-4"
        :class="{ 'facility-text-small': facility.name.length > 18 }"
      >
        {{ facility.name }}
      </div>
    </button>
  </p>
</template>

<script>
import Checkbox from "@/components/atoms/Checkbox.vue";
import { mapMutations, mapGetters } from "vuex";
export default {
  components: {
    Checkbox,
  },
  data() {
    return {};
  },
  methods: {
    ...mapMutations(["toggleFacility"]),
    select(event) {
      event.target.blur();
      this.toggleFacility(this.facility);
      this.$emit("update");
    },
  },
  computed: {
    ...mapGetters(["facilities"]),
    selected() {
      let index = this.facilities.indexOf(this.facility);
      let result = this.facilities[index].selected;
      return result;
    },
  },
  props: {
    facility: {
      type: Object,
    },
  },
};
</script>

<style scoped>
.button {
  border: 2px solid #dcdcdc;
}

.checkboxContainer {
  position: absolute;
  top: calc((100% - 2.1rem) / 2) !important; 
  left: 2.5% !important;
}

.facility-text-small {
  font-size: calc(0.8rem + 0.1vw);
}

.facility:hover,
.active-facility {
  border: 2px solid #00c5fd !important;
}

.w90 {
  width: 90%;
}
</style>
